import Owner from "./Owner.model";

export default class Organization {
  name: string | null;
  owner: Owner | null;
  uuid: string | null;

  constructor(name: string | null = null, owner: Owner | null = null, uuid: string | null = null) {
    this.name = name;
    this.owner = owner;
    this.uuid = uuid;
  }
}
